import type { BaseClient } from '../../http/BaseClient.js';
import {
  normalizeSystemEvent,
  SystemEventQuery,
  SystemEventQueryResponse,
  SystemEventReadResponse,
  WireSystemEvent,
} from './types.js';

interface WireQueryResponse {
  events: WireSystemEvent[];
  total: number;
  skip: number;
  take: number;
}

export class SystemEventsClient {
  constructor(private readonly http: BaseClient) {}

  async query(body: SystemEventQuery): Promise<SystemEventQueryResponse> {
    const wire = await this.http.post<WireQueryResponse>('/systemevent', { body });
    return {
      events: (wire.events ?? []).map(normalizeSystemEvent),
      total: wire.total ?? 0,
      skip: wire.skip ?? 0,
      take: wire.take ?? 0,
    };
  }

  markRead(eventIdOrIds: number | number[]): Promise<SystemEventReadResponse> {
    const body = Array.isArray(eventIdOrIds) ? { ids: eventIdOrIds } : { id: eventIdOrIds };
    return this.http.post<SystemEventReadResponse>('/systemevent/read', { body });
  }

  markUnread(eventIdOrIds: number | number[]): Promise<SystemEventReadResponse> {
    const body = Array.isArray(eventIdOrIds) ? { ids: eventIdOrIds } : { id: eventIdOrIds };
    return this.http.delete<SystemEventReadResponse>('/systemevent/read', { body });
  }
}
